import React, { useEffect, useState } from "react";
import S from "./LatestAssets.styled";
import { Flex } from "@/styles/global";
import { H3 } from "@/styles/typography";
import { Icon, TextButton } from "@/styles/components";
import { motion } from "framer-motion";
import { IWPLink } from "@/src/types";
import useAssetsData from "@/src/useData/useAssetsData";
import { format } from "date-fns";

type Assets = {
  title: string;
  uri: string;
  date: string;
  assetsInfo: {
    file: {
      mimeType: string;
      localFile: {
        publicURL: string;
      };
    };
  };
};

export interface LatestAssetsProps {
  blockId?: string;
  title: string;
  link: IWPLink;
}

const LatestAssets: React.FC<LatestAssetsProps> = ({
  title,
  link,
  blockId = "",
}) => {
  const [latestAssets, setLatestAssets] = useState<Assets[]>([]);
  const assets = useAssetsData();

  useEffect(() => {
    const latest = assets.slice(0, 6);
    setLatestAssets(latest);
  }, [assets]);

  return (
    <S.Section id={blockId}>
      <S.Inner>
        <S.Title id="Blogs">{title}</S.Title>
        <Flex $gap={16} $desktopGap={24}>
          {link && <TextButton wpLink={link} color="black" underlined />}
        </Flex>
      </S.Inner>
      <S.Cards
        as={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, type: "spring" }}
      >
        {latestAssets.map((asset, i) => {
          const date = new Date(asset.date);

          return (
            <S.Card
              href={asset.assetsInfo.file.localFile.publicURL}
              target="_blank"
              key={i}
            >
              <Flex $gap={8} $column $justify="between" $height="100%">
                <H3 color="creme">{asset.title}</H3>
                <S.CardDate color="creme">
                  {format(date, "dd MMMM, yyyy")}
                </S.CardDate>
              </Flex>
              <Icon src="ArrowDown" width={20} color="creme" />
            </S.Card>
          );
        })}
      </S.Cards>
    </S.Section>
  );
};

export default LatestAssets;
